// extracted by mini-css-extract-plugin
export default {"menu":"Menu_menu__lH6Jt","menu__wrap":"Menu_menu__wrap__TH+3y","menu__sections":"Menu_menu__sections__IQxex"};